<template>
<div class="row">

  <div class="col-12">
    <div class="form-group">
      <label for="booking">{{$t('message.schedules.booking_number_per_time_slot')}}</label>
      <multiselect id="booking" class="booking-options" v-model="booking" selected-label="" select-label="" deselect-label="" placeholder="" :options="numberOptions" :allow-empty="false"></multiselect>
      <p id="bookingHelpInline" class="form-text text-muted">
        {{$t('message.schedules.booking_number_per_time_slot_e_g')}}
      </p>
    </div>
    <div class="form-divider"></div>
  </div>

</div>
</template>

<script>

import jq from 'jquery'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    jq,
    Multiselect
  },
  props: {
    clinic_id: Number,
    doctor_id: Number,
    booking_per_slot: Number,
    number_options: Array
  },
  data () {
    let minNumber = 1
    let maxNumber = 5
    return {
      booking: 4,
      numberOptions: this.generateNumber(minNumber, maxNumber).map(v => v.toString())
    }
  },
  methods: {
    generateNumber (start, end) {
      return Array.from({length: (end - start)}, (v, k) => k + start)
    }
  },
  watch: {
    booking (v, old) {
      if (v) {
        this.$emit('bookingPerSlotChanged', this.clinic_id, parseInt(v))
      }
    }
  },
  created () {
    if (this.booking_per_slot) {
      this.booking = this.booking_per_slot
    }

    if (this.number_options) {
      this.numberOptions = this.number_options
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.form-divider{
  height: 1px;
  border: 1px dashed #eee;
  margin: 10px 0;
  width: 100%;
}

.booking-options {
  width: 4rem !important;
  text-align-last: center;
}

</style>



// WEBPACK FOOTER //
// WorkingBookingPerSlot.vue?23465270